import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Container, Stack } from '@mui/material';
import { useAdminAuth } from '../context/AdminAuthContext';

export function AdminRoute() {
  const { loading, isAuthenticated } = useAdminAuth();

  if (loading) {
    return (
      <Container>
        <Stack alignItems="center" sx={{ py: 8 }}>
          <CircularProgress />
        </Stack>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
}
